import * as React from 'react';
import Icon, { ICON_STOPWATCH_LINE } from '~/components/icon/index.js';
import { HeadWrapper, MainTitle, SubTitle } from '~/components/misc/section-head.js';
import { ActionScreenButton } from '~/components/misc/action-screen.js';
import ButtonWrapper from '~/components/misc/button-wrapper.js';

/**
 * Action screen Button
 * @param {object} props
 * @param {Function} props.onClick
 * @param {string} props.dataAt
 * @param {string} props.text
 */
const Button = ({ onClick, dataAt, text, className }) => (
	<ActionScreenButton
		type="button"
		className={`btn ${className}`}
		actionType="default-info"
		onClick={onClick}
		dataAt={dataAt}
	>
		{text}
	</ActionScreenButton>
);

/**
 * Button Group is a collection of buttons rendered based on configuration
 * @param {object} props
 * @param {array} props.config
 * @param {boolean} props.isSwedishRegulatedFranchise
 */
const ButtonGroup = ({ config = [], isSwedishRegulatedFranchise = false }) => {
	const [orientation, setOrientation] = React.useState(window?.orientation ?? 0);

	React.useEffect(() => {
		const handleOrientation = () => {
			setOrientation(window.orientation);
		};
		window.addEventListener('orientationchange', handleOrientation, false);
		return () => window.removeEventListener('orientationchange', handleOrientation);
	}, []);

	return (
		<ButtonWrapper pt={3} pb={3} transparent>
			{isSwedishRegulatedFranchise ? (
				<div
					className={
						orientation !== 0
							? 'btn-container--landscape btn-container btn-container--double u-flex'
							: 'btn-container--portrait'
					}
				>
					{config.map(btn => (
						<Button {...btn} key={btn.dataAt} />
					))}
				</div>
			) : (
				<>
					{config.map(btn => (
						<Button {...btn} key={btn.dataAt} />
					))}
				</>
			)}
		</ButtonWrapper>
	);
};

/**
 * TODO: Can be refactored more to license specific later instead of german or swedish if cases.
 * Reality Check Common Vew
 * @param {object} props
 * @param {object} props.texts | Trasnsilation texts for the messages
 * @param {boolean} props.isSwedishRegulatedFranchise | If its a swedish franchise
 * @param {boolean} props.isGermanFranchise | If its a german franchise
 * @param {array} props.buttonConfig | Array of buttons based on license
 */

const RealityCheckView = ({
	texts = {},
	isSwedishRegulatedFranchise = false,
	isMaltaRegulatedFranchise = false,
	isGermanFranchise = false,
	buttonConfig = []
}) => {
	const betSumAmount = texts.MOBILE_REALITY_CHECK_BET_SUM.startsWith('-')
		? texts.MOBILE_REALITY_CHECK_BET_SUM.substring(1)
		: texts.MOBILE_REALITY_CHECK_BET_SUM;
	return (
		<div className="modal-view modal-view--fixed reality-check-modal">
			<div className="notify--is-open reality-check-confirm u-height-100">
				<HeadWrapper className="u-scroll-content-wrapper u-pb-xl2">
					<Icon type={ICON_STOPWATCH_LINE} />
					<MainTitle>{texts.MOBILE_REALITY_CHECK_HEADER}</MainTitle>
					{isGermanFranchise && <SubTitle>{texts.MOBILE_REALITY_CHECK_MESSAGE_UPPER}</SubTitle>}
					<div className="u-mt2">
						<h3 className="reality-check__time-header u-result-header u-m0">
							{isGermanFranchise
								? texts.MOBILE_REALITY_CHECK_TIME_COOLDOWN
								: texts.MOBILE_REALITY_CHECK_TIME_PLAYED_HEADER}
						</h3>
						<h2 className="reality-check__time-result u-result">
							{isGermanFranchise && <span>{texts.MOBILE_REALITY_CHECK_COOLDOWN_PERIOD}</span>}
							{!isGermanFranchise && texts.MOBILE_REALITY_CHECK_PLAY_TIME}
						</h2>
						<h3 className="reality-check__sum-header u-result-header u-m0">
							{isGermanFranchise
								? texts.MOBILE_REALITY_CHECK_PLAY_TIME
								: texts.MOBILE_REALITY_CHECK_BET_SUM_HEADER}
						</h3>
						<h2 className="reality-check__sum-result u-result">
							{isGermanFranchise
								? texts.playedTime
								: `${texts.MOBILE_REALITY_CHECK_BET_SUM_TEXT} ${betSumAmount}`}
						</h2>
						{isGermanFranchise && (
							<>
								<h3 className="reality-check__sum-header u-result-header u-m0">
									{texts.MOBILE_REALITY_CHECK_BET_SUM_HEADER}
								</h3>
								<h2 className="reality-check__sum-result u-result">{texts.betSum}</h2>
							</>
						)}
						{isMaltaRegulatedFranchise && texts.MOBILE_REALITY_CHECK_TOTAL_WAGERED && (
							<>
								<h3 className="reality-check__sum-header u-result-header u-m0">
									{texts.MOBILE_REALITY_CHECK_WAGERED_HEADER}
								</h3>
								<h2 className="reality-check__sum-result u-result">
									{texts.MOBILE_REALITY_CHECK_TOTAL_WAGERED}
								</h2>
							</>
						)}
						{isMaltaRegulatedFranchise && (
							<h3 className="reality-check__sum-header u-result-header u-m0">
								{texts.MOBILE_REALITY_CHECK_RG_MESSAGE}
							</h3>
						)}
						{isSwedishRegulatedFranchise && (
							<h3 className="reality-check__message u-message">
								{texts.MOBILE_REALITY_CHECK_MESSAGE_UPPER}
							</h3>
						)}
					</div>
				</HeadWrapper>
				<ButtonGroup config={buttonConfig} isSwedishRegulatedFranchise={isSwedishRegulatedFranchise} />
			</div>
		</div>
	);
};

export default RealityCheckView;
